import firebase from 'firebase'

firebase.auth().languageCode = 'pt';

export const doSingIn = (email, password) =>{
    return firebase.auth().signInWithEmailAndPassword(email, password)
}

export const doResetPassword = email => {
    return firebase.auth().sendPasswordResetEmail(email)
}

export const doLogout = () => {
    return firebase.auth().signOut()
}


// WEBPACK FOOTER //
// ./src/js/firebase/firebase-auth.js